import Grid from '@mui/material/Grid'
import { Typography } from '@mui/material'
import InvoicePreview from '../../../atoms/InvoicePreview/InvoicePreview'
import styles from '../index.module.scss'
const SummaryTab = () => {
	return (
		<div className={styles.templateTaxTab}>
			<Grid container spacing={1.5} sx={{ marginBottom: '15px' }}>
				<Grid size={{ xs: 12, md: 12 }}>
					<div className={styles.title}>
						<Typography variant="h6">
							Invoice Summary
							<span>(Standard template)</span>
						</Typography>
					</div>
				</Grid>
				<Grid size={{ xs: 12, md: 12 }}>
					<div className={styles.title}>
						<InvoicePreview />
					</div>
				</Grid>
			</Grid>
		</div>
	)
}

export default SummaryTab
